import { FC } from 'react'

import styled from 'styled-components'

import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'

import { MAX_MOBILE_WIDTH } from '../../../Styled/variables'

import { PlaylistInfo } from './PlaylistInfo'

interface PlaylistInfoItemProps {
  playlistName: string
  followers: number
  genres: string[]
  coverUrl?: string
  playlistUrl?: string
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: ${({ theme }) => theme.color.white};
  width: 100%;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    max-width: 678px;
    min-width: 232px;
  }
`

const PlaylistInfoWrapper = styled.div`
  flex: 1;
  max-width: 340px;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 100%;
    width: 100%;
  }
`

const GenresContainer = styled.div`
  flex: 1;
  min-width: 320px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    min-width: auto;
    padding-left: 64px;
    width: 100%;
  }
`

export const PlaylistInfoItem: FC<PlaylistInfoItemProps> = ({
  playlistName,
  followers,
  genres,
  coverUrl,
  playlistUrl,
}) => (
  <Container>
    <PlaylistInfoWrapper>
      <PlaylistInfo
        playlistName={playlistName}
        followers={followers}
        coverUrl={coverUrl}
        playlistUrl={playlistUrl}
      />
    </PlaylistInfoWrapper>

    <GenresContainer>
      {genres.map((genre) => capitalizeFirstLetter(genre)).join(', ')}
    </GenresContainer>
  </Container>
)
